interface AvatarProps {
  firstName: string;
  lastName: string;
  className?: string;
}

/**
 * Avatar component that displays user initials
 */
export function Avatar({ firstName, lastName, className = "" }: AvatarProps) {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-accent text-white font-semibold ${className}`}
      aria-label={`${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
}
